import styled from 'styled-components';
import { ReactComponent as RawMobileSVG } from '../../../../assets/icons/icon_mobile.svg';

export const IconMobile = styled(RawMobileSVG)``;